import React from 'react';
import Breadcrumbs from '../containers/breadcrumbs';

const PageContainer = (props) => (
  <div>
    <Breadcrumbs/>
    {props.children}
  </div>
);

export default PageContainer;



// WEBPACK FOOTER //
// ./src/views/page-container.js